import React from "react";
import { useGetTermsAndConditionsQuery } from "../../lib/redux/services/sections/Auth";
import Loader from "../skeletons/Loader";
//@ts-ignore
import terms from "../../assets/pdf/Terms.pdf";
import MarkReader from "../global/MarkReader";
import { useGetPoliciesQuery } from "../../lib/redux/services/Api";
const TermsModal = ({ onClose, name, href }: any) => {
  // const { data, isFetching } = useGetTermsAndConditionsQuery("");

  // if (isFetching) {
  //   return (
  //     <div className="h-[90vh]">
  //       <Loader />
  //     </div>
  //   );
  // }

  const { data, isFetching } = useGetPoliciesQuery({
    categories: [name],
    type: "club",
  });

  console.log(data?.data[0]?.version?.file_url);

  return (
    <div className="text-start h-full flex-col flex justify-between">
      {/* <p className="px-8 text-start py-4 whitespace-break-spaces text-pretty">
        {data?.data[name]}
      </p> */}
      {/* <div className=" w-full   flex justify-center items-center w">
        <div className="w-[90%] ">
          <iframe
            allowFullScreen
            className="h-[83vh]"
            src={terms}
            title="invoice"
            height="100%"
            width="100%"
          />
        </div>
      </div> */}

      {isFetching ? (
        <div className="flex flex-col items-center h-full">
          {" "}
          <Loader />
        </div>
      ) : (
        <MarkReader file_name={data?.data[0]?.version?.file_url} />
      )}

      <button
        onClick={() => {
          onClose();
        }}
        className=" flex justify-center items-center py-2 w-full     "
      >
        <p
          onClick={onClose}
          className="px-10 py-1 hover:cursor-pointer   rounded-lg hover:bg-red-600 hover:text-white transition duration-300 border-red-600 border text-red-600 w-fit "
        >
          Close
        </p>
      </button>
    </div>
  );
};

export default TermsModal;
